// extracted by mini-css-extract-plugin
export default {"createApplicationRoot":"CreateApplication_createApplicationRoot__TbnTi"};